import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {phoneNumber} from "../../constants/constants";

const StyledWhatsappLink = styled.a`
z-index: 1000;
      position: fixed;
      bottom: 0;
      right: 0;
      margin-right: 20px;
      margin-bottom: 20px;
`;
const StyledWhatsappImage = styled.img.attrs({
  src: 'https://s3.us-east-2.amazonaws.com/finauta/png/wa1.png',
})`
      width: 60px;
      height: 60px;
  `;


const WhatsappCTA = ({
  message,
}) => (
  <StyledWhatsappLink href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURI(message)}`}>
    <StyledWhatsappImage />
  </StyledWhatsappLink>
);

WhatsappCTA.propTypes = {
  message: PropTypes.string,
};

WhatsappCTA.defaultProps = {
  message: 'Hola 👋',
};

export default WhatsappCTA;
